import React, { useState, useEffect, useRef, useCallback } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/themes/material_blue.css";
import "./investment-request-list.css";
import DropdownTest from "../Create-Investment/ndrop";
import Dropdown from "../../Components/CustomDropdown/customdropdown";
import InvestorDetailPopup from "./investor-detail-popup";
import DocumentPopup from "../../Components/TableWithFilters/view-application-popup";
import { useToast } from "../../Utils/toastContext";
import { svgLogoBase64 } from "../../Constants/config";
import { debounce } from "lodash";

const InvestmentRequestList = () => {
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const { showToast } = useToast();
  const [filter, setFilter] = useState("");
  const [showRecords, setShowRecords] = useState(10);
  const [selected, setSelected] = useState("Download Report");
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [filterText, setFilterText] = useState("created_at");
  const [status, setStatus] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [isOpenStatus, setisOpenStatus] = useState(false);
  const [isUserPopOpen, setisUserPopOpen] = useState(false);
  const [isHidden, setIsHidden] = useState(false); // Initially hidden
  const [loading, setLoading] = useState(false);
  const [pdfData, setPdfData] = useState([]); // Initially hidden

  const location = useLocation();

  const buttonRef = useRef({});
  const dropdownRef = useRef();
  const DateCalendarRef = useRef();

  const AllStatus = [
    { label: "Approved", value: "approved" },
    { label: "Rejected", value: "rejected" },
  ];

  const handleSelect = (option) => {
    setSelected(option.label);
    setIsOpen(false);
  };

  const navigate = useNavigate();

  const [data, setData] = useState(null);
  const [filteredData, setfilteredData] = useState(null);
  const [totalPages, settotalPages] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [selectedRange, setSelectedRange] = useState("Select Date Range");
  const [selectedDates, setSelectedDates] = useState([]);
  const [quickFilter, setQuickFilter] = useState("");
  const [currentInvestmentId, setCurrentInvestmentId] = useState("");
  const [totalCount, settotalCount] = useState(0);
  const [showPopup, setShowPopup] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const today = new Date();
  const formattedDate = `${String(today.getDate()).padStart(2, "0")}-${String(
    today.getMonth() + 1
  ).padStart(2, "0")}-${today.getFullYear()}`;

  const toggleDropdown = () => setIsDropdownOpen((prev) => !prev);
  const DownloadDocRef = useRef();

  // Predefined quick filters
  const quickFilters = [
    { label: "This Week", value: "this_week" },
    { label: "Last Week", value: "last_week" },
    { label: "This Month", value: "this_month" },
    { label: "This Year", value: "this_year" },
    { label: "Last Year", value: "last_year" },
    { label: "Custom", value: "custom" },
    { label: "All Time", value: "" },
  ];
  const [openDropdown, setOpenDropdown] = useState(null);

  const handleDropdownToggle = (id) => {
    // Toggle dropdown for the specific row
    if (openDropdown === id) {
      setOpenDropdown(null); // Close if already open
    } else {
      setOpenDropdown(id); // Open the dropdown for the specific row
    }
  };
  useEffect(() => {
    const handleClickOutside = (event) => {
      // Check if click happened outside all dropdowns
      const isOutside = !Object.values(buttonRefs.current).some((ref) =>
        ref?.contains(event.target)
      );

      if (isOutside) {
        setOpenDropdown(null); // Close dropdown if clicked outside
      }
      if (
        DateCalendarRef.current &&
        !DateCalendarRef.current.contains(event.target)
      ) {
        setIsDropdownOpen(false);
      }
      if (
        DownloadDocRef.current &&
        !DownloadDocRef.current.contains(event.target)
      ) {
        setIsOpen(false);
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);
  useEffect(() => {
    if (selectedDates.length === 2) {
      const formattedRange = `${formatDate(
        selectedDates[0].toLocaleDateString()
      )} — ${formatDate(selectedDates[1].toLocaleDateString())}`;
      setSelectedRange(formattedRange);
    }
  }, [selectedDates]);
  const formatDateList = (dateString) => {
    const [datePart] = dateString.split(" "); // Extract the date portion
    const [day, month, year] = datePart.split("/"); // Split into day, month, and year
    return `${day}/${month}/${year}`;
  };
  const clearFilter = () => {
    setOpenDropdown(null);
    setCurrentPage(1);
    setSearchQuery("");
    setShowRecords(10);
    setpreSelectedFilter({
      value: 10,
      label: "10",
    });
    setSelectedDates([]);
    setSelectedRange("Select Date Range");
  };
  // Handle quick filter selection
  const handleQuickFilter = (filter) => {
    const today = new Date();
    let startDate, endDate;
    setCurrentPage(1);

    if (filter === "this_week") {
      // Adjust to start from Monday
      const dayOfWeek = today.getDay() === 0 ? 6 : today.getDay() - 1; // Adjust for Monday as first day
      startDate = new Date(today.setDate(today.getDate() - dayOfWeek));
      endDate = new Date(startDate);
      endDate.setDate(startDate.getDate() + 6); // End of the week
    } else if (filter === "last_week") {
      const dayOfWeek = today.getDay() === 0 ? 6 : today.getDay() - 1; // Adjust for Monday as first day
      endDate = new Date(today.setDate(today.getDate() - dayOfWeek - 1)); // End of last week
      startDate = new Date(endDate);
      startDate.setDate(endDate.getDate() - 6); // Start of last week
    } else if (filter === "this_month") {
      startDate = new Date(today.getFullYear(), today.getMonth(), 1);
      endDate = new Date(today.getFullYear(), today.getMonth() + 1, 0);
    } else if (filter === "this_year") {
      startDate = new Date(today.getFullYear(), 0, 1);
      endDate = new Date(today.getFullYear(), 11, 31);
    } else if (filter === "last_year") {
      startDate = new Date(today.getFullYear() - 1, 0, 1);
      endDate = new Date(today.getFullYear() - 1, 11, 31);
    } else if (filter === "custom") {
      // Custom filter: enable calendar range selection and reset dates
      setSelectedDates([]);
      setSelectedRange("Select Date Range");
      setQuickFilter(filter);
      return;
    } else if (filter === "") {
      // Custom filter: enable calendar range selection and reset dates
      setSelectedDates([]);
      setSelectedRange("Select Date Range");
      setQuickFilter(filter);
      return;
    }
    setQuickFilter(filter);
    setSelectedDates([startDate, endDate]);
    setSelectedRange(
      `${startDate.toLocaleDateString()} — ${endDate.toLocaleDateString()}`
    );
  };
  const formatDateForFilter = (dateString) => {
    const date = new Date(dateString);

    // Extract year, month, and date
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Adding 1 since months are 0-indexed
    const day = String(date.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`; // Format as yyyy-dd-mm
  };
  const formatDate = (dateString) => {
    const date = new Date(dateString); // Convert string to Date object
    const day = String(date.getDate()).padStart(2, "0"); // Get day with leading zero
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Get month (0-indexed) with leading zero
    const year = date.getFullYear(); // Get full year

    return `${day}/${month}/${year}`; // Format as DD/MM/YYYY
  };
  const GetAPIcalls = async (url) => {
    const token = localStorage.getItem("jwtToken");
    const apiUrl = `${BASE_URL}${url}`;
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }

    try {
      const response = await fetch(apiUrl, {
        method: "GET",
        headers,
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }
      return await response.json();
    } catch (error) {
      console.error("API Call Error:", error); // Log full error for debugging
      throw new Error(
        typeof error.message === "string"
          ? error.message
          : "Network error, please try again later"
      );
    }
  };
  const handleViewApplications = async (e, investment_request_id) => {
    try {
      const response = await GetAPIcalls(
        `/v1/document/investment-portfolio/${investment_request_id}`
      );

      if (response.status == 200) {
        if (response.data == null) {
          setTimeout(function () {
            setLoading(false);
            setSelectedFiles([]);
            setShowPopup(false);
            showToast(response.message, "error");
            return;
          }, 1000);
        } else {
          setTimeout(function () {
            setLoading(false);
            setSelectedFiles(response.data);
            setShowPopup(true);
          }, 1000);
        }
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
        if (response.status === 400) {
          setSelectedFiles([]);
        }
      }
    } catch (err) {
      setTimeout(function () {
        setLoading(false);
        showToast(err.message, "error");
      }, 1000);
    } finally {
    }
  };
  const GetInvestmentList = async () => {
    setIsLoading(true);
    const token = localStorage.getItem("jwtToken");
    const direction = sortConfig.direction === "asc" ? "desc" : "asc";
    let apiUrl = "";
    if (selectedDates.length == 2) {
      apiUrl =
        filter == ""
          ? `${BASE_URL}/v1/investment-request/all?page=${currentPage}&sort_by=${filterText}&sort_order=${direction}&size=${showRecords}&search=${searchQuery}&start_date=${formatDateForFilter(
              selectedDates[0]
            )}&end_date=${formatDateForFilter(selectedDates[1])}`
          : `${BASE_URL}/v1/investment-request/all?page=${currentPage}&status=${filter}&sort_by=${filterText}&sort_order=${direction}&size=${showRecords}&search=${searchQuery}&start_date=${formatDateForFilter(
              selectedDates[0]
            )}&end_date=${formatDateForFilter(selectedDates[1])}`;
    } else {
      apiUrl =
        filter == ""
          ? `${BASE_URL}/v1/investment-request/all?page=${currentPage}&sort_by=${filterText}&sort_order=${direction}&size=${showRecords}&search=${searchQuery}`
          : `${BASE_URL}/v1/investment-request/all?page=${currentPage}&sort_by=${filterText}&sort_order=${direction}&status=${filter}&size=${showRecords}&search=${searchQuery}`;
    }

    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    setSortConfig({ key: null, direction });

    try {
      const response = await fetch(apiUrl, {
        method: "GET",
        headers,
      });
      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));

        throw new Error(errorData.message || "Something went wrong");
      }
      return await response.json();
    } catch (error) {
      throw new Error(error.message || "Network error, please try again later");
    }
  };
  const getAll = async () => {
    try {
      const response = await GetInvestmentList();

      if (response.status == 200) {
        setData(response.data.investment_requests);
        setfilteredData(response.data.investment_requests);
        settotalPages(response.data.total_pages);
        setCurrentPage(response.data.page);
        settotalCount(response.data.total_count);
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
        setfilteredData([]);
        console.log("I am wlslsk" + filteredData);
      }
    } catch (err) {
      showToast(err.message, "error");
    } finally {
      setTimeout(function () {
        setIsLoading(false);
      }, 100);
    }
  };
  function createTableHeader(columns) {
    const thead = document.createElement("thead");

    // Create thead
    const headRow = document.createElement("tr");
    columns.forEach((col) => {
      const th = document.createElement("th");
      th.textContent = col.label;
      if (col.width) th.style.width = col.width;
      if (col.minWidth) th.style.minWidth = col.minWidth;
      headRow.appendChild(th);
    });
    thead.appendChild(headRow);
    return thead;
  }
  const GetInvestmentListForPdf = async () => {
    const token = localStorage.getItem("jwtToken");
    const direction = sortConfig.direction === "asc" ? "desc" : "asc";
    let apiUrl = "";
    if (selectedDates.length == 2) {
      apiUrl =
        filter == ""
          ? `${BASE_URL}/v1/investment-request/all?sort_by=${filterText}&sort_order=${direction}&size=100&search=${searchQuery}&start_date=${formatDateForFilter(
              selectedDates[0]
            )}&end_date=${formatDateForFilter(selectedDates[1])}`
          : `${BASE_URL}/v1/investment-request/all?status=${filter}&sort_by=${filterText}&sort_order=${direction}&size=100&search=${searchQuery}&start_date=${formatDateForFilter(
              selectedDates[0]
            )}&end_date=${formatDateForFilter(selectedDates[1])}`;
    } else {
      apiUrl =
        filter == ""
          ? `${BASE_URL}/v1/investment-request/all?sort_by=${filterText}&sort_order=${direction}&size=100&search=${searchQuery}`
          : `${BASE_URL}/v1/investment-request/all?sort_by=${filterText}&sort_order=${direction}&status=${filter}&size=100&search=${searchQuery}`;
    }

    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }

    try {
      const response = await fetch(apiUrl, {
        method: "GET",
        headers,
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));

        throw new Error(errorData.message || "Something went wrong");
      }
      return await response.json();
    } catch (error) {
      throw new Error(error.message || "Network error, please try again later");
    }
  };
  const downloadPDF = useCallback(
    debounce(async (e, option) => {
      // if (option.value == "csv") {
      //   try {
      //     const csvBlob = await GetCSV();
      //     const url = window.URL.createObjectURL(csvBlob);
      //     const a = document.createElement("a");
      //     a.href = url;
      //     a.download = `Investment Portfolios-${formattedDate}.csv`;
      //     document.body.appendChild(a);
      //     a.click();
      //     document.body.removeChild(a);
      //     window.URL.revokeObjectURL(url);
      //   } catch (err) {
      //     if (err.message.includes("401")) {
      //       localStorage.removeItem("jwtToken");
      //       navigate("/login");
      //     }
      //     if (err.message.includes("400")) {
      //       toast.error(
      //         <div className="flex items-center">
      //           <div className="mr-3">
      //             <img
      //               src="/tick-error.svg"
      //               alt="Success Icon"
      //               className="h-6 w-6"
      //             />
      //           </div>
      //           <div>
      //             <h3 className="font-semibold text-md text-black">Error!</h3>
      //             <p className="text-sm text-black">{err.message}</p>
      //           </div>
      //         </div>,
      //         {
      //           position: "top-right",
      //           autoClose: 5000,
      //           hideProgressBar: true,
      //           closeOnClick: true,
      //           pauseOnHover: true,
      //           draggable: true,
      //           icon: false,
      //           closeButton: (
      //             <button
      //               className="text-black "
      //               onClick={() => toast.dismiss()}
      //               style={{
      //                 backgroundColor: "transparent",
      //                 border: "none",
      //                 marginBottom: "2.813rem",
      //               }}
      //             >
      //               ✖
      //             </button>
      //           ),
      //           className: "error-toast text-md  rounded text-black",
      //         }
      //       );
      //     }
      //   } finally {
      //     setTimeout(function () {
      //       setLoading(false); // Ensure `loading` is false first
      //     }, 100);
      //   }
      // }
      if (option.value == "pdf") {
        try {
          const response = await GetInvestmentListForPdf();

          if (response.status == 200) {
            setPdfData(response.data.investment_requests);
            setIsHidden(true);
          } else {
            if (response.status === 401) {
              localStorage.removeItem("jwtToken");
              navigate("/login");
            }
            setPdfData([]);
            console.log("I am wlslsk" + filteredData);
          }
        } catch (err) {
          if (err.status === 401) {
            localStorage.removeItem("jwtToken");
            navigate("/login");
          }
          setPdfData([]);
          showToast(err.message, "error");
        }
      }
    }, 1000), // Debounce time
    [filter, filterText, searchQuery, sortConfig, selectedDates] // Dependencies
  );
  function createTableBody() {
    const body = document.createElement("tbody");

    pdfData.forEach((row) => {
      const tr = document.createElement("tr");
      tr.classList.add("tbody-tr");

      tr.innerHTML = `
          <td>${formatDateList(row.date_created)}</td>
          <td>${row.status.charAt(0).toUpperCase() + row.status.slice(1)}</td>
          <td>${row.investor_name}</td>
          <td>${row.product_name}</td>
                    <td>$${row.amount
                      .toFixed(2)
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</td>
                    <td>$${(row.cash_account == null
                      ? 0.0
                      : row.cash_account.toFixed(2)
                    )
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</td>
        `;
      body.appendChild(tr);
    });
    return body;
  }
  const handleDownloadPDF = async () => {
    const columns = [
      { label: "Date", key: "created_at" },
      { label: "Status", key: "status" },
      { label: "Investor Name", key: "investor_name" },
      { label: "Product Name", key: "product_name" },
      { label: "Investment Amount", key: "amount" },
      { label: "Cash Account", key: "cash_account" },
    ];
    const date = new Date().toLocaleString();
    const tableHeadElement = createTableHeader(columns);
    const tableHeader = tableHeadElement.outerHTML;
    const tableBodyElement = createTableBody();
    const tableBody = tableBodyElement.outerHTML;
    const fullHtml = `
        <!DOCTYPE html>
        <html>
          <head>
            <meta charset="utf-8" />
            <style>
            @page {
      size: A4 landscape;
      margin: 0;
    }
      html, body {
              margin: 0;
              padding: 0;
                        font-family:sans-serif;
      overflow: auto;  /* Ensure content can overflow */
    
              height: 100%; /* Ensure the body fills the entire height */
            }        .pdf-container {
                max-width: 100% !important;
                margin: 20px;
              }
              tr {
                page-break-inside: avoid !important;
                break-inside: avoid !important;
              }
      
              .custom-header {
                position: relative;
                display: flex;
                justify-content: space-between;
                background-color: #ffffff;
                padding-top: 10px; /* Ensures no padding at the top */
              }
      
              .logo-container {
                display: flex;
                align-items: center;
              }
      
              .logo {
                width: 96px; /* Tailwind w-24 = 6rem = 96px */
                max-width: 150px;
                height: auto;
                object-fit: contain;
                margin-right: 1rem;
              }
      
              .title {
                position: absolute;
                left: 50%;
                transform: translateX(-50%);
                font-size: 1.125rem; /* Tailwind text-lg */
                font-weight: 500;    /* Tailwind font-medium */
                padding: 0;          /* Remove any padding */
                margin: 0;           /* Remove any margin */
              }
      
              .date {
                font-size: 0.875rem;  /* Tailwind text-sm */
                font-weight: 500;
                color: #000000;
                padding-bottom: 16px;
              }
    
      
    .page-break {
             page-break-before: always;
      break-before: page;
      display: block;
      height: 0; /* No extra space */
      width: 100%;
      content: "";}
          table {
          width: 100%;
          border-collapse: collapse;
          table-layout: fixed;
        }
    
        thead {
          font-size: 10px;
          color: #6B7280; /* Tailwind text-labelColour equivalent */
        }
    
        th {
          border-bottom: 1px solid #000;
          padding: 8px;
          text-align: left;
        }
              td {
          padding: 6px;
          font-size: 10px;
          vertical-align: middle;
          text-align: left;
        }
          .tbody-tr{
                      background-color: #F9F9F9;
                      margin-bottom: 10px;
    
          }
            </style>
          </head>
          <body>
         <div class="pdf-container">
            <div class="custom-header">
              <div class="logo-container">
                <img src="${svgLogoBase64}" alt="Company Logo" class="logo" />
              </div>
              <h2 class="title">Investment Requests</h2>
              <div class="date">${date}</div>
            </div>
            
      <table id="dynamic-table">
      ${tableHeader}
        ${tableBody}
    
      </table>
        
          </div> 
    
               </body>
        </html>
      `;

    const token = localStorage.getItem("jwtToken");
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const response = await fetch(
      `${BASE_URL}/v1/investment-portfolio/generate-pdf`,
      {
        method: "POST",
        headers: headers,
        body: JSON.stringify({ html: fullHtml }),
      }
    );
    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `Investment Requests-${formattedDate}.pdf`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    setLoading(false);
    setIsHidden(false);
  };
  useEffect(() => {
    if (isHidden == true) {
      handleDownloadPDF();
    }
  }, [isHidden]);
  const options = [
    { value: "pdf", label: "PDF" },
    { value: "csv", label: "CSV" },
  ];
  const UpdateStatusCall = async (option, rowId) => {
    const token = localStorage.getItem("jwtToken");
    const headers = {
      "Content-Type": "application/json",
    };

    const apiUrl = `${BASE_URL}/v1/investment-request/${rowId}/status`;
    const bodyData = {
      status: option.value,
    };
    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    try {
      const response = await fetch(apiUrl, {
        method: "PUT",
        headers,
        body: JSON.stringify(bodyData),
      });
      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || "Network error, please try again later");
    }
  };

  const handleStatusChange = useCallback(
    debounce(async (e, option, rowId) => {
      e.preventDefault();
      let toastMessage = null;
      try {
        const response = await UpdateStatusCall(option, rowId);
        if (response.status == 200) {
          setStatus(rowId + option.value);
          setisOpenStatus(false);
          toastMessage = { message: response.message, type: "success" };
        } else {
          toastMessage = { message: response.message, type: "error" };
        }
      } catch (err) {
        toastMessage = { message: err.message, type: "error" };
      } finally {
        setLoading(false); // Ensure `loading` is false first
        // Show toast after loading is false
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 300); // Small delay if needed
        }
      }
    }, 1000), // Debounce time
    [] // Dependencies
  );
  const handleSort = (key) => {
    setFilterText(key);
    getAll();
  };

  useEffect(() => {
    getAll();
  }, [filter, showRecords, currentPage, status, selectedDates, searchQuery]);

  const headers = [
    { label: "Date", key: "created_at" },
    { label: "Status", key: "status" },
    { label: "Investor Name", key: "investor_name" },
    { label: "Product Name", key: "product_name" },
    { label: "Investment Amount", key: "amount" },
    { label: "Cash Account", key: "cash_account" },
    { label: "", key: "" }, // No sorting for actions
  ];
  const buttonRefs = useRef({});
  const handleScroll = (indexToRemove) => {
    console.log("I an scroll in document");
    setOpenDropdown(null);
  };
  const filterOptions = [
    { value: 10, label: "10" },
    { value: 20, label: "20" },
    { value: 30, label: "30" },
    { value: 50, label: "50" },
  ];

  const [preSelectedFilter, setpreSelectedFilter] = useState({
    value: 7,
    label: "10",
  });
  const handleFilterChange = (selectedOption) => {
    console.log("Selected Option:", selectedOption);
    setShowRecords(parseInt(selectedOption.value));
    setCurrentPage(1);
  };
  const handleUserClick = (investmentID) => {
    setCurrentInvestmentId(investmentID);
    setisUserPopOpen(true);
  };
  useEffect(() => {
    if (openDropdown != null) {
      console.log("Dropdown for create opened, adding scroll event listener.");
      window.addEventListener("scroll", handleScroll, { passive: true });
    } else {
      console.log(
        "Dropdown for create closed, removing scroll event listener."
      );
      window.removeEventListener("scroll", handleScroll);
    }

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [openDropdown]);
  return (
    <div className="">
      {loading && (
        <div className="fixed top-0 left-0 w-full h-full flex justify-center items-center bg-black bg-opacity-50 z-[999]">
          <div className="w-12 h-12 border-4 border-white border-t-transparent rounded-full animate-spin"></div>
        </div>
      )}
      <div onScroll={handleScroll} className="overflow-y">
        <div className="pt-6 pr-4 flex-wrap items-center">
          <div className="flex mb-2">
            <button
              onClick={() => {
                setFilter("");
                clearFilter();
              }}
              className={`px-4 py-2 lg:w-20 rounded-l-xl border-r border-gray-100 ${
                filter === "" ? "bg-black text-white" : "bg-white text-black"
              }`}
            >
              New
            </button>
            <button
              onClick={() => {
                setFilter("approved");
                clearFilter();
              }}
              className={`lg:px-4 px-2 py-2 border-r border-gray-100 ${
                filter === "approved"
                  ? "bg-black text-white"
                  : "bg-white text-black"
              }`}
            >
              Approved
            </button>
            <button
              onClick={() => {
                setFilter("rejected");
                clearFilter();
              }}
              className={`px-4 py-2 rounded-r-xl ${
                filter === "rejected"
                  ? "bg-black text-white"
                  : "bg-white text-black"
              }`}
            >
              Rejected
            </button>
          </div>
        </div>
        <div className="w-full p-4 bg-white rounded-lg shadow-lg">
          <div className="flex justify-between items-center mb-4 border-b pb-5 border-gray-100">
            <div className="flex items-center">
              <img
                src="/money-receive.svg"
                alt="Company Logo"
                className="mr-3"
              />
              <span className="font-medium lg:text-xl text-sm">
                Investment Requests
              </span>
            </div>
          </div>
          <div className="flex justify-between flex-col lg:flex-row flex-wrap mb-4 gap-4 mb-4">
            <div className="flex items-left flex-col lg:flex-row flex-wrap  gap-4 lg:space-x-4 lg:space-y-0 space-x-0">
              <div className="flex items-center space-x-2">
                <span className="lg:text-md  text-sm text-[#8C8C8C]">
                  Show Records
                </span>
                <Dropdown
                  label=""
                  options={filterOptions}
                  preselectedValue={preSelectedFilter}
                  onSelect={handleFilterChange}
                />
              </div>
              <div className="flex items-center">
                <div className="relative">
                  <input
                    type="text"
                    className="p-2 pl-8 border rounded-xl"
                    placeholder="Search Requests"
                    value={searchQuery}
                    onChange={(e) => {
                      setCurrentPage(1);
                      setSearchQuery(e.target.value);
                    }}
                  />
                  <span className="absolute left-2 top-3 text-gray-500">
                    {" "}
                    <img
                      src="/search-normal.svg"
                      alt="Company Logo"
                      className="mr-2"
                    />
                  </span>
                </div>
              </div>
            </div>

            <div className="flex justify-end flex-col lg:flex-row flex-wrap mb-4 gap-4 mb-4">
              <div
                ref={DateCalendarRef}
                className="flex items-center space-x-4"
              >
                <div className="relative w-full">
                  {/* Dropdown Trigger */}
                  <div
                    className="flex items-center justify-between p-2 w-60 md:w-60 border rounded-xl bg-white cursor-pointer"
                    onClick={toggleDropdown}
                  >
                    <span>{selectedRange}</span>
                    <img
                      src="/download-small-arrow.svg"
                      alt="Dropdown"
                      className="w-2 h-2"
                    />
                  </div>

                  {/* Dropdown */}
                  {isDropdownOpen && (
                    <div className="absolute top-12  md:left-1/4 left-1/2 transform -translate-x-1/2 mt-2 bg-white border rounded-lg shadow-lg z-10 w-[90vw] md:w-[900px] max-h-[400px] overflow-auto">
                      <div className="flex  flex-col md:flex-row h-full">
                        {/* Left: Quick Filters */}
                        <div className="w-full md:w-1/3 border-r p-3 h-full">
                          {quickFilters.map((filter) => (
                            <div
                              key={filter.value}
                              className={`p-2 cursor-pointer rounded ${
                                quickFilter === filter.value
                                  ? "bg-black text-white"
                                  : "hover:bg-gray-200 text-black"
                              } transition-all duration-200 ease-in-out`}
                              onClick={() => handleQuickFilter(filter.value)}
                            >
                              {filter.label}
                            </div>
                          ))}
                        </div>

                        {/* Right: Calendar */}
                        <div className="w-full md:w-2/3 overflow-auto p-3 h-full">
                          <Flatpickr
                            key={selectedDates}
                            options={{
                              mode: "range",
                              inline: true,
                              dateFormat: "Y-m-d",
                              showMonths: 2,
                              defaultDate:
                                selectedDates.length > 0 ? selectedDates : [],
                              shorthandCurrentMonth: true,
                              locale: {
                                firstDayOfWeek: 1, // Sets Monday as the first day of the week
                              },
                              onChange: (dates) => {
                                if (
                                  quickFilter === "custom" &&
                                  dates.length === 2
                                ) {
                                  setSelectedDates(dates);
                                }
                              },
                            }}
                            className="w-full"
                          />
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
              <div className="flex items-center space-x-4">
                <div ref={DownloadDocRef} className="relative inline-block ">
                  <div
                    className="flex justify-between items-center p-3 border border-gray-200 h-11 w-60 rounded-xl cursor-pointer"
                    onClick={() => setIsOpen(!isOpen)}
                  >
                    <img
                      src="/document-download.svg"
                      alt="document-download"
                      className="mr-2"
                    />
                    <span>{selected}</span>
                    <span className="text-gray-500">
                      {" "}
                      <img
                        src="/download-small-arrow.svg"
                        alt="Dropdown"
                        className="w-2 h-2"
                      />
                    </span>
                  </div>
                  {isOpen && (
                    <ul className="absolute left-0 w-full bg-white border border-gray-300 rounded-md shadow-md mt-1 z-10">
                      {options.map((option) => (
                        <li
                          key={option.value}
                          className="flex items-center p-2 hover:bg-gray-200 cursor-pointer"
                          onClick={(e) => {
                            e.preventDefault();
                            setLoading(true);
                            downloadPDF(e, option);
                          }}
                        >
                          {option.label}
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              </div>
            </div>
          </div>

          {/* Table */}
          <div onScroll={handleScroll} className="overflow-x-auto">
            <table className="w-full h-full border border-gray-200">
              {/* Table Header */}
              <thead className="text-[#8C8C8C] text-sm">
                <tr>
                  {headers.map((header) => (
                    <th
                      key={header.label}
                      onClick={() => handleSort(header.key)}
                      className="cursor-pointer w-40 font-medium px-4 py-2 border-b text-left"
                    >
                      {/* {header}
            <img src="/sort.svg" alt="sort icon" className="w-4 h-4 ml-2" /> */}
                      <div class="flex items-center">
                        <span>{header.label}</span>
                        {header.key != "" && (
                          <img
                            src="/sort.svg"
                            alt="Icon"
                            class="w-4 h-4 ml-2"
                          />
                        )}
                      </div>
                    </th>
                  ))}
                </tr>
              </thead>

              {isLoading ? (
                <tbody className="shimmer-container-list ">
                  {/* Creating 5 rows of shimmer effect */}
                  {[...Array(5)].map((_, rowIndex) => (
                    <tr key={rowIndex} className="shimmer-row-list">
                      {/* Creating 7 cells in each row for shimmer */}
                      {[...Array(7)].map((_, colIndex) => (
                        <td key={colIndex} className="shimmer-cell-list">
                          <div className="shimmer-loader"></div>
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              ) : (
                <tbody className="text-sm font-medium text-black">
                  {filteredData.length > 0 ? (
                    filteredData.map((row) => (
                      <tr className="mb-2 bg-[#F9F9F9]">
                        <td className="px-4 py-2">
                          {formatDateList(row.date_created)}
                        </td>

                        {/* Dropdown Button */}
                        <td className="px-4 py-2 relative">
                          <button
                            ref={(el) => (buttonRefs.current[`${row.id}`] = el)}
                            disabled={row.status == "pending" ? false : true}
                            onClick={() => handleDropdownToggle(row.id)}
                            className={` w-40  font-medium h-10 rounded-xl text-sm px-2 py-2  flex justify-between items-center focus:outline-none${
                              row.status == "pending"
                                ? " border-2 border-[#F77E27] text-[#F77E27] bg-[#F1DCCD]"
                                : ""
                            }
                              ${
                                row.status == "approved"
                                  ? " border-2 border-[#34C046] disabled text-[#34C046] bg-[#93DB9C]"
                                  : ""
                              }
                              ${
                                row.status == "rejected"
                                  ? " border-2 border-[#FF5050] disabled text-[#FF5050] bg-[#E9BDBD]"
                                  : ""
                              }
                              `}
                          >
                            <span className="mr-6">
                              {" "}
                              {row.status.charAt(0).toUpperCase() +
                                row.status.slice(1)}
                            </span>
                            {row.status == "pending" && (
                              <img
                                src={`${
                                  openDropdown === row.id
                                    ? "/Vector.svg"
                                    : "/down-grey.svg"
                                }`}
                                alt="Selected"
                                className="w-3 h-3 ml-4"
                              />
                            )}
                          </button>
                          <DropdownTest
                            isOpen={openDropdown === row.id}
                            buttonRef={buttonRefs.current[`${row.id}`]} // Pass unique ref to the dropdown
                          >
                            <div
                              ref={dropdownRef}
                              className="absolute left-0 bg-white rounded-md shadow-lg overflow-hidden z-50 w-full max-w-[200px] border"
                              style={{
                                position: "absolute",
                                top: "100%",
                                left: 0,
                              }}
                            >
                              {AllStatus.map((option) => (
                                <div
                                  key={option.value}
                                  onClick={(e) => {
                                    e.preventDefault();
                                    setLoading(true);
                                    handleStatusChange(e, option, row.id);
                                  }}
                                  className={`px-4 py-2 p-3 w-30 mx-2 my-1 text-sm cursor-pointer flex items-center justify-between rounded-xl ${
                                    option.value === "approved"
                                      ? "border-2 border-[#34C046] text-[#34C046] bg-[#93DB9C] hover:bg-[#34C046] hover:text-white"
                                      : "border-2 border-[#FF5050] text-[#FF5050] bg-[#E9BDBD] hover:bg-[#FF5050] hover:text-white"
                                  }`}
                                >
                                  <span>{option.label}</span>
                                </div>
                              ))}
                            </div>
                          </DropdownTest>
                        </td>

                        <td
                          onClick={() => handleUserClick(row.id)}
                          className="px-4 py-2 text-ellipsis cursor-pointer overflow-hidden whitespace-nowrap"
                        >
                          {row.investor_name}
                        </td>
                        <td className="px-4 py-2 text-left text-ellipsis  overflow-hidden whitespace-nowrap">
                          {row.product_name}
                        </td>
                        <td className="px-4 py-2 text-center">
                          <span>
                            $
                            {row.amount
                              .toFixed(2)
                              .toString()
                              .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                          </span>
                        </td>
                        <td className="px-4 py-2 text-center">
                          $
                          {(row.cash_account == null
                            ? 0.0
                            : row.cash_account.toFixed(2)
                          )
                            .toString()
                            .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                        </td>

                        <td
                          onClick={(e) => {
                            e.preventDefault();
                            setLoading(true);
                            handleViewApplications(e, row.investment_id);
                          }}
                          className="px-4 py-2  text-ellipsis  overflow-hidden whitespace-nowrap"
                        >
                          <span className="text-black bg-white px-2 py-2 cursor-pointer rounded-xl">
                            View Applications
                          </span>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td className="text-center py-4" colSpan="7">
                        No results found
                      </td>
                    </tr>
                  )}
                </tbody>
              )}
              {showPopup && (
                <DocumentPopup
                  isOpen={showPopup}
                  onClose={() => setShowPopup(false)}
                  files={selectedFiles}
                />
              )}
            </table>
          </div>
          {isUserPopOpen && (
            <InvestorDetailPopup
              investmentID={currentInvestmentId}
              onClose={() => setisUserPopOpen(false)}
            />
          )}
          {!isLoading && (
            <div className="flex flex-wrap justify-between items-center mt-4 space-y-4 sm:space-y-0">
              {/* Entries Info Section */}
              <div className="text-[#8C8C8C] text-sm sm:text-base w-full sm:w-auto text-center sm:text-left">
                Showing {showRecords * (currentPage - 1) + 1} to{" "}
                {currentPage === totalPages || totalPages == 0
                  ? totalCount
                  : Math.max(
                      showRecords * currentPage,
                      filteredData.length
                    )}{" "}
                of {totalCount} entries
              </div>

              {/* Pagination Section */}
              <div className="flex flex-wrap items-center justify-center sm:justify-end font-semibold text-sm gap-2 w-full sm:w-auto">
                {/* Previous Button */}
                <button
                  disabled={currentPage === 1}
                  onClick={() => setCurrentPage((prev) => prev - 1)}
                  className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  Prev
                </button>

                {/* Page Buttons */}
                {Array.from({ length: Math.min(totalPages, 5) }).map(
                  (_, index) => {
                    const startPage = Math.max(
                      1,
                      Math.min(totalPages - 4, currentPage - 2)
                    );
                    const page = startPage + index;

                    return (
                      <button
                        key={page}
                        onClick={() => setCurrentPage(page)}
                        className={`px-3 py-1 rounded ${
                          currentPage === page
                            ? "bg-black text-white"
                            : "bg-white border border-gray-300 text-black"
                        }`}
                      >
                        {page}
                      </button>
                    );
                  }
                )}

                {/* Next Button */}
                <button
                  disabled={currentPage === totalPages}
                  onClick={() => setCurrentPage((prev) => prev + 1)}
                  className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  Next
                </button>
              </div>
            </div>
          )}
        </div>
      </div>{" "}
    </div>
  );
};

export default InvestmentRequestList;
